enum ToastTheme {
  Default = 'default',
  Error = 'error',
}

export default ToastTheme;
